export const OBTAIN_PAGE = "/obtain";
export const _searchCardInputs = [
    {
        label: "프로젝트 코드",
        key: "projectCode",
        col: "12",
        sm: "2",
        lg: "2",
        value: "",
    },
    {
        label: "사내 견적번호",
        key: "inhouseBidNumber",
        col: "12",
        sm: "3",
        lg: "3",
        value: "",
    },
    {
        label: "기업별 입찰번호",
        key: "companyBidNumber",
        col: "12",
        sm: "3",
        lg: "3",
        value: "",
    },
    {
        label: "업체명",
        key: "companyName",
        col: "12",
        sm: "2",
        lg: "2",
        value: "",
    },
];
export const _headers = [
    { text: "단계", align: "center", value: "approvalPhase" },
    { text: "발행일", align: "start", value: "createdTime" },
    { text: "프로젝트 코드", align: "start", value: "projectCode" },
    { text: "사내 견적번호", align: "start", value: "inhouseBidNumber" },
    { text: "기업별 입찰번호", align: "start", value: "companyBidNumber" },
    { text: "작성자", align: "start", value: "createrName" },
    { text: "업체명", align: "start", value: "companyName" },
    { text: "총액", align: "start", value: "totalPrice" },
    { text: "", align: "center", value: "actions", sortable: false },
];
